import React from "react"

const LoadingContext = React.createContext(null)

export default LoadingContext
